export default __webpack_public_path__ + "static/media/leader-head-bg.be9876da.png";